export class MarketingContact {
    id: number;
    email: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/marketing-contact.ts